import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/index.vue'

const routers: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: Layout,
        redirect: '/course',
        name: 'dashboard',
        meta: {
            // showMenu: true,
            title: '首页',
        },
        // children: [
        //     {
        //         path: '/dashboard',
        //         name: "dashboard-index",
        //         meta: {
        //             title: "首页",
        //         },
        //         component: () => import("@/views/index.vue"),
        //     },
        // ],
    },
    {
        path: '/course',
        component: Layout,
        name: 'course',
        redirect: '/course/index',
        meta: {
            title: '我的课程',
            showMenu: true,
        },
        children: [
            {
                path: 'index',
                name: 'course-index',
                meta: {
                    title: '我的课程',
                },
                component: () => import('@/views/course/index.vue'),
            },
            {
                path: 'homework',
                name: 'course-homework',
                meta: {
                    title: '课程作业',
                },
                component: () => import('@/views/course/homework.vue'),
            },
        ],
    },
    {
        path: '/note',
        component: Layout,
        name: 'note',
        redirect: '/note/index',
        meta: {
            title: '教务信息',
            showMenu: true,
        },
        children: [
            {
                path: 'index',
                name: 'note-index',
                meta: {
                    title: '教务信息',
                },
                component: () => import('@/views/note/index.vue'),
            },
            {
                path: 'detail',
                name: 'note-detail',
                meta: {
                    title: '教务信息详情',
                },
                component: () => import('@/views/note/detail.vue'),
            },
        ],
    },
    {
        path: '/thesis',
        component: Layout,
        name: 'thesis',
        redirect: '/thesis/current',
        meta: {
            title: '我的论文',
            showMenu: true,
        },
        children: [
            {
                path: 'current',
                name: 'thesis-current',
                meta: { title: '当前流程' },
                component: () => import('@/views/thesis/current.vue'),
            },
            {
                path: 'notice',
                name: 'thesis-notice',
                meta: { title: '通知公告' },
                component: () => import('@/views/thesis/notice.vue'),
            },
            {
                path: 'mentor',
                name: 'thesis-mentor',
                meta: { title: '双选导师' },
                component: () => import('@/views/thesis/mentor.vue'),
            },
            {
                path: 'proposal',
                name: 'thesis-proposal',
                meta: { title: '开题报告' },
                component: () => import('@/views/thesis/proposal.vue'),
            },
            {
                path: 'draft',
                name: 'thesis-draft',
                meta: { title: '初稿' },
                component: () => import('@/views/thesis/draft.vue'),
            },
            {
                path: 'check',
                name: 'thesis-check',
                meta: { title: '评阅稿' },
                component: () => import('@/views/thesis/check.vue'),
            },
            {
                path: 'tutor-review',
                name: 'thesis-tutor-review',
                meta: { title: '导师评阅' },
                component: () => import('@/views/thesis/tutorReview.vue'),
            },
            {
                path: 'review-feedback',
                name: 'thesis-review-feedback',
                meta: { title: '专家送审' },
                component: () => import('@/views/thesis/reviewFeedback.vue'),
            },
            {
                path: 'defense-submit',
                name: 'thesis-defense-submit',
                meta: { title: '答辩稿' },
                component: () => import('@/views/thesis/defenseSubmit.vue'),
            },
            {
                path: 'defense-arrange',
                name: 'thesis-defense-arrange',
                meta: { title: '正式答辩' },
                component: () => import('@/views/thesis/defenseArrange.vue'),
            },
            {
                path: 'defense-result',
                name: 'thesis-defense-result',
                redirect: '/thesis/defense-arrange',
            },
            {
                path: 'final',
                name: 'thesis-final',
                meta: { title: '终稿' },
                component: () => import('@/views/thesis/finalSubmit.vue'),
            },
        ],
    },
    {
        path: '/personal',
        component: Layout,
        name: 'personal',
        redirect: '/personal/index',
        meta: {
            title: '个人资料',
        },
        children: [
            {
                path: 'index',
                name: 'personal-info',
                meta: {
                    title: '个人资料',
                },
                component: () => import('@/views/personal/index.vue'),
            },
        ],
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login.vue'),
        meta: {
            noRole: true,
            title: '登录',
        },
    },
    {
        path: '/401',
        name: '401',
        component: () => import('@/views/system/401.vue'),
        meta: {
            noRole: true,
            title: '401',
        },
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/system/404.vue'),
        meta: {
            noRole: true,
            title: '404',
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/system/404.vue'),
        meta: {
            noRole: true,
            title: '404',
        },
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes: routers,
})

export default router
